/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-others': {
    width: 8,
    height: 36,
    viewBox: '0 0 8 36',
    data: '<path pid="0" d="M4 7.579A3.79 3.79 0 114 0a3.79 3.79 0 010 7.579zm0-5.684a1.895 1.895 0 100 3.79 1.895 1.895 0 000-3.79zM4 36a3.79 3.79 0 110-7.579A3.79 3.79 0 014 36zm0-5.684a1.895 1.895 0 100 3.79 1.895 1.895 0 000-3.79zm0-8.527a3.79 3.79 0 110-7.578 3.79 3.79 0 010 7.578zm0-5.684a1.895 1.895 0 100 3.79 1.895 1.895 0 000-3.79z" _fill="#005BA5" fill-rule="evenodd"/>'
  }
})
